import { Component } from 'react';

import getBoxes from './boxes';

const isContextEqual = (nextContext, context) => {
  const { scope, customerId, contractId } = nextContext;
  return (
    `${scope}${customerId}${contractId}` !==
    `${context.scope}${context.customerId}${context.contractId}`
  );
};

export default class BoxesSelector extends Component {
  shouldComponentUpdate(nextProps) {
    return isContextEqual(nextProps.context, this.props.context);
  }

  render() {
    const { context, translation } = this.props;

    return getBoxes(context, translation);
  }
}
